import { FC } from 'react';

import { Redirect } from '@core/navigation';
import { RoutePath } from '@common/constants';

export const Index: FC = () => {
  return <Redirect path={RoutePath.ROOT_MORE_INSURANCE} />;
};
